import idleTimer from 'aria-viewer/utils/idleTimer'

// Singleton store manager
const StoreManager = {
    store: null,

    setStore: store => {
        StoreManager.store = store
    },

    getStore: () => {
        return StoreManager.store
    },
}

export default ({ callback, activeCallback, intervalCB, idleTime, intervalTime }) => {
    if (idleTime) {
        const cb = () => {
            const store = StoreManager.getStore()

            if (typeof callback == 'function') callback(store)
        }

        const activeCB = () => {
            const store = StoreManager.getStore()

            if (typeof activeCallback == 'function') activeCallback(store)
        }

        new idleTimer({
            callback: cb, // function to fire after idle
            activeCallback: activeCB, // function to fire when active after being idle
            idleTime, // Amount of time in milliseconds before becoming idle
        })
    }

    if (intervalTime) {
        setInterval(() => {
            const store = StoreManager.getStore()

            if (typeof intervalCB == 'function') intervalCB(store)
        }, intervalTime)
    }

    return store => next => action => {
        StoreManager.setStore(store)

        next(action)
    }
}
